var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._b({attrs:{"label":"","dark":"","small":"","color":_vm.color}},'v-chip',_vm.$attrs,false),[_c('BaseIcon',{attrs:{"iconName":_vm.iconName,"small":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }